import { useAllergens } from 'context/Store';
import { useIngredientCategories } from 'context/Store';
import { useBaseIngredientList } from 'context/Store';
import { useNutrientList } from 'context/Store';
import { useSeasons } from 'context/Store';
import { useTagList } from 'context/Store';
import { useUnitList } from 'context/Store';

export default function useIngredientData() {
	const allergens = useAllergens();
	const baseIngredients = useBaseIngredientList();
	const categories = useIngredientCategories();
	const nutrients = useNutrientList();
	const seasons = useSeasons();
	const tags = useTagList();
	const units = useUnitList();

	return {
		allergens,
		baseIngredients,
		categories,
		nutrients,
		seasons,
		tags,
		units,
	};
}

export type IngredientDetailData = ReturnType<typeof useIngredientData>;
